<template>
  <div>
    <v-container class="company-info mx-auto pa-0">
      <h2 class="company-info--heading">{{ introContent.title }}</h2>
      <p
        class="company-info--description"
        v-for="(text, i) in introContent.content"
        :key="i"
        v-html="text.paragraph"
      ></p
    ></v-container>
  </div>
</template>
<script>
export default {
  props: {
    introContent: {
      type: Object,
      required: true
    }
  }
}
</script>
